import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import { imageBaseUrl } from 'src/cms/helpers/constants'
import { ISettingTypeState } from '../siteSettings/components/settings'
import Callback from './Callback'
import { EmailSuccess } from './components/EmailSuccess'
import { ForgotPassword } from './components/ForgotPassword'
import { Login } from './components/Login'
import { NewPassword } from './components/NewPassword'
import { OtpValidation } from './components/OtpValidation'
import { ResetPassword } from './components/ResetPassword'
import { UpdatePassword } from './components/UpdatePassword'

export function AuthPage() {
  const [logo, setLogo] = useState('')
  const [applicationName, setAplicationName] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  // const getToken = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual)
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(item?.value)
          }
        })

      settingTypeData?.backendData &&
        settingTypeData?.backendData['Application Credentials']?.map((item: any) => {
          if (item?.name === 'applicationName') {
            setAplicationName(item?.value)
          }
        })
    }
  }, [settingTypeData])

  return (
    <>

      <div className='row g-0 min-vh-100'>
        <div className='col-lg-8 p-0 position-relative d-none d-lg-block'>
          <div
            style={{
              backgroundImage: 'url("/media/kumari.png")',
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "100vh",
              width: "100%",
            }}
          />
        </div>
        <div className='col-12 col-lg-4 p-0'>
          <div className='login-wrapper'>
            <div className='login-box'>
              <div className='login-logo text-center'>
                <img
                  className='img-fluid mx-auto'
                  src={`${imageBaseUrl}/${logo}` || `/media/logos/global-ime-logo-svg.jpg`}
                  alt=''
                  style={{ maxWidth: '350px', width: '100%' }}
                />
              </div>
              {/* /.login-logo */}
              <div className='login-box-body'>
                <Switch>
                  <Route path='/auth/login/:id?' component={Login} />
                  <Route path='/auth/set-password/:id?' component={NewPassword} />
                  <Route path='/auth/forgot-password' component={ForgotPassword} />
                  <Route path='/auth/verify-otp' component={OtpValidation} />
                  <Route path='/auth/reset-password/:id' component={ResetPassword} />
                  {/* <Route path='/auth/verify-user' component={VerifyUser} /> */}

                  <Route path='/callback' component={Callback} />
                  <Route path='/auth/success' component={EmailSuccess} />
                  <Route path='/auth/update-password/:id?' component={UpdatePassword} />
                  {/* <Route path='/sso' component={SingleSignOn} /> */}

                  {/* {getToken && ( */}

                  {/* )} */}

                  <Redirect from='/auth' exact={true} to='/auth/login' />
                  <Redirect to='/auth/login' />
                </Switch>
              </div>
              {/* /.login-box-body */}
            </div>
          </div>
        </div>
      </div>
      {/* // ) : (
      //   <Switch>
      //     <Route path='/sso' component={SingleSignOn} />
      //     <Route path='/auth/login/:id?' component={Login} />
      //     <Route path='/auth/set-password/:id?' component={NewPassword} />
      //     <Route path='/auth/forgot-password' component={ForgotPassword} />
      //     <Route path='/auth/verify-otp' component={OtpValidation} />
      //     <Route path='/auth/reset-password/:id' component={ResetPassword} />
      //     <Route path='/auth/verify-user' component={VerifyUser} />

      //     <Route path='/callback' component={Callback} />
      //     <Route path='/auth/success' component={EmailSuccess} />
      //     <Route path='/auth/update-password/:id?' component={UpdatePassword} />
      //     <Redirect to='/auth/login' />
      //   </Switch>
      // )} */}
    </>
  )
}
